import { ProjectSharing } from "components/ProjectSharing/ProjectSharing";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";

export const ProjectTabAccess = () => {
  const projectId = useDataTableContext((s) => s.project.id);
  return <ProjectSharing projectId={projectId} mode="flex" />;
};
